import Loading from "components/Loading";
import React, { useCallback, useEffect, useState } from "react";
import NewWheelComponent from "./NewBingoWheel";
import * as Sentry from '@sentry/react';
const BingoWheelComponent = (props) => {
  const {
    result,
    isTeacher,
    selectedUser,
    segColors,
    loader,
    bingoData,
    cooldown,
    remainingTime,
    debateResponse,
    debateInfo,
    disableAutoSpin = false,
    autoSpinIntervalOverride = null,
    intervalSpinNonce = 0
  } = props?.states || null;
  const { onFinished, setIsWheelSpinning, playAutoSpin } = props?.funcObj || null;
  const [dimensions, setDimensions] = useState({});
  const [showAccordin, setShowAccordin] = useState(true);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleResize = () => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  const getSegments = useCallback(() => {
    try {
      if (Array.isArray(bingoData) && bingoData.length > 0) {
        const segmentData = bingoData.map((k, i) => ({
          color: segColors[i] || segColors[i % segColors.length] || "#000000", // Fallback color
          label: k?.value ?? "",
          imageUrl: k.imageUrl,
        }));
        return segmentData;
      }
      return [];
    } catch (error) {
      Sentry.captureException(`583 Error in getSegments: ${error}`);
      console.error("Error in getSegments:", error);
      return [];
    }
  }, [bingoData, segColors]);

  return (
    <div
      className="checkListTopSection"
      style={{
        position: "relative",
        height: showAccordin ? "100%" : "0px",
        display: "grid",
        placeItems: "center",
        padding: "0px",
      }}
    >
      {showAccordin && (
        <>
          {loader === "fetchContent" && loader?.value ? (
            <Loading size={30} />
          ) : (
            <>
              <span className="text-center mb-10px spin-wheel-time h-45px">
                {cooldown
                  ? `The next spin will be available after ${remainingTime}s. `
                  : ""}
              </span>
              <div className="flex flex-col">
                <NewWheelComponent
                  key={`${debateResponse?.id || 'no-debate'}`}
                  dimensions={dimensions}
                  segments={getSegments()}
                  onFinished={onFinished}
                  newStudentList={selectedUser}
                  cooldown={cooldown}
                  loader={loader?.type === "wheel_spin" && loader?.value}
                  debateInfo={debateInfo}
                  disableAutoSpin={disableAutoSpin}
                  autoSpinIntervalOverride={autoSpinIntervalOverride}
                  setIsWheelSpinning={setIsWheelSpinning}
                  remainingTime={remainingTime}
                  intervalSpinNonce={intervalSpinNonce}
                  playAutoSpin={playAutoSpin}
                />
              </div>
                {debateInfo?.bingo_type !== 'OnlyImage' && (
                  <>
                    {result !== "" && (
                      <div className="widget-wheel-text">{result}</div>
                    )}
                  </>
                )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default BingoWheelComponent;
